import { render, staticRenderFns } from "./AuditReportNotice.vue?vue&type=template&id=2fcb2c6e&scoped=true&"
import script from "./AuditReportNotice.vue?vue&type=script&lang=js&"
export * from "./AuditReportNotice.vue?vue&type=script&lang=js&"
import style0 from "./AuditReportNotice.vue?vue&type=style&index=0&id=2fcb2c6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb2c6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
